import CustomSwitch from '../common/CustomSwitch';
import useEmailNotification from '../../hooks/useEmailNotification';

const EmailNotification = () => {
    const [receiveTransactionEmail, handleGetEmail] = useEmailNotification();

    return (
        <>
            <p className="px-6 py-4 self-stretch text-text text-sm font-semibold leading-5">
                EMAIL NOTIFICATIONS
            </p>

            <div
                className="flex justify-between items-center !p-5 self-stretch rounded-md bg-card-bg mx-6 mt-3 mb-6"
                data-e2e="receive-transctions-emails">
                <p className="text-text text-sm font-semibold leading-5 uppercase">
                    Receive transactional email confirmations.
                </p>

                <CustomSwitch
                    data-e2e="yes-no-btn"
                    sx={{ m: 1 }}
                    onChange={handleGetEmail}
                    checked={receiveTransactionEmail}
                />
            </div>
        </>
    );
};

export default EmailNotification;
